import { DestroyRef, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { interval } from 'rxjs';

/** Intervalle par défaut entre deux rafraîchissements silencieux des listes publiques. */
const DEFAULT_POLL_MS = 60000;

/**
 * Ré-exécute périodiquement `callback` tant que le composant appelant est vivant, pour que les
 * listes publiques (opportunités, événements, actualités, témoignages) reflètent les nouvelles
 * publications admin sans que le visiteur ait à rafraîchir la page. Doit être appelée depuis un
 * contexte d'injection (constructeur de composant), comme `inject()`.
 */
export function pollSilently(callback: () => void, intervalMs = DEFAULT_POLL_MS): void {
  const destroyRef = inject(DestroyRef);
  interval(intervalMs)
    .pipe(takeUntilDestroyed(destroyRef))
    .subscribe(callback);
}
